import Calculator from './Calculator';

export default Calculator;


// WEBPACK FOOTER //
// ./src/html/components/Calculator/index.js